import React from "react";

import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PropTypes from "prop-types";

const ExportButton = ({ onClick, size, loading }) => (
  <Button className="export-btn" disabled={loading} onClick={onClick}>
    <Icon>
      <FontAwesomeIcon icon="download" size={size} />
    </Icon>
  </Button>
);

ExportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  loading: PropTypes.bool,
};

ExportButton.defaultProps = {
  size: "lg",
  loading: false,
};

export default ExportButton;
